export default __webpack_public_path__ + "static/media/dif02.0b9d5965.svg";